<template>
    <div class="field">
      <label class="label">{{inputName}}</label>
      <div class="control">
          <div class="select" :class="field.error ? 'is-danger' : ''" style="width: 100%; height: 42px;">
            <select v-model="field.value" style="width: 100%;  -webkit-box-shadow: 0 1px 2px rgba(10, 10, 10, 0.05); box-shadow: 0 1px 2px rgba(10, 10, 10, 0.05); border-radius: 2px; padding-left: 15px; height: 42px;" @change="modified">
              <option v-for="option in options" v-bind:key="option">{{option}}</option>
            </select>
          </div>
      </div>
      <p class="help is-danger" v-if='field.error'>{{field.error}}</p>
    </div>
</template>

<script>
export default {
  name: 'Input',
  model () {
    return {value: '', error: '', typed: false}
  },
  props: {
    inputField: Object,
    inputName: String,
    inputType: String,
    options: Array
  },
  data () {
    return {
      field: this.inputField
    }
  },
  methods: {
    modified () {
      this.field.typed = true
      this.validate()
    },
    validate () {
      console.log('validating')
      this.field.error = null
      if (!this.field.value || this.field.value.length < 2) {
        this.field.error = 'Please enter a valid '+this.inputName
      }
      console.log(this.field.error)
      return this.field.error == null
    },
    setValue (s) {
      this.field.value = s
      this.modified()
    }
  }
}
</script>
